import React from 'react';
import SafeIcon from '../common/SafeIcon.jsx';
import * as FiIcons from 'react-icons/fi';

const { FiImage, FiLoader } = FiIcons;

const GenerateButton = ({ onGenerate, isGenerating, disabled }) => {
  return (
    <div className="flex justify-center">
      <button
        onClick={onGenerate}
        disabled={disabled || isGenerating}
        className={`px-8 py-4 rounded-lg font-semibold text-white transition-all duration-200 flex items-center space-x-2 ${
          disabled || isGenerating
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-blue-600 hover:bg-blue-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1'
        }`}
      >
        <SafeIcon 
          icon={isGenerating ? FiLoader : FiImage} 
          className={`w-5 h-5 ${isGenerating ? 'animate-spin' : ''}`}
        />
        <span>{isGenerating ? 'Generating...' : 'Generate Marketing Image'}</span>
      </button>
    </div>
  );
};

export default GenerateButton;